import { initializeApp } from "firebase/app";
import React from 'react';
import './App.css';
import AppNav from './AppNav';


/// TODO: Check Every Time When Deploying.

// Demo Account - Staging.
// const demo_account_firebaseConfig = {
//   apiKey: "AIzaSyB14tSADQIQ4SWdfzfs70CdQkIdgHfmeOk",
//   authDomain: "fir-content-panel.firebaseapp.com",
//   projectId: "fir-content-panel",
//   storageBucket: "fir-content-panel.appspot.com",
//   messagingSenderId: "1061569580903",
//   appId: "1:1061569580903:web:b9911a53d3f58d9059e9c2"
// };
// export const BASE_SERVER_URL = "https://admin-api.staging.tellmeaffirmations.com"; // Staging API
// const app = initializeApp(demo_account_firebaseConfig);

// Real Account - Production 
const firebaseConfig = {
  apiKey: "AIzaSyC8QmqoLtGxAL8RrXLUP_un9tn0HkOBbWI",
  authDomain: "mindfulness-beta.firebaseapp.com",
  databaseURL: "https://mindfulness-beta-default-rtdb.firebaseio.com",
  projectId: "mindfulness-beta",
  storageBucket: "mindfulness-beta.appspot.com",
  messagingSenderId: "934870412411",
  appId: "1:934870412411:web:4ee33b52bd1a7051d106de",
  measurementId: "G-C346Z3K1D0"
};
export const BASE_SERVER_URL = "https://admin-api.tellmeaffirmations.com"; // Production API
const app = initializeApp(firebaseConfig);


// export const BASE_SERVER_URL = "http://localhost:4000/";


function App() {

  return (
    <div className="App">
      <AppNav/>
    </div>
  );
}

export default App;
